export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          {/* Visual */}
          <div className="w-full lg:w-2/5 flex justify-center">
            <div className="relative w-[260px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 border-2 border-background-300/50 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20app%20interface%20mockup%20for%20entertainment%20video%20platform%2C%20dark%20theme%20UI%20with%20crimson%20and%20amber%20accent%20colors%2C%20video%20thumbnail%20grid%20layout%2C%20modern%20sleek%20design%2C%20content%20discovery%20feed%2C%20clean%20minimalist%20mobile%20app%20aesthetic&width=540&height=960&seq=app-mobile-mockup&orientation=portrait"
                alt="黑料手机客户端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">随时随地 · 手机端畅享</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              黑料不打烊手机客户端全面支持 iOS 和 Android 双平台，
              随时随地打开手机就能观看最新黑料内容。流畅的视频播放体验、
              智能的内容推荐算法，让你不错过任何一条精彩视频。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-6">
              <div className="flex items-center gap-2 bg-background-50 border border-background-300/40 rounded-lg px-4 py-2.5">
                <i className="ri-apple-line text-lg text-foreground-700"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">iOS 版下载</span>
              </div>
              <div className="flex items-center gap-2 bg-background-50 border border-background-300/40 rounded-lg px-4 py-2.5">
                <i className="ri-android-line text-lg text-foreground-700"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">Android 版下载</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-5 mt-6 justify-center lg:justify-start">
              <div className="flex flex-col items-center">
                <span className="text-xl font-heading font-bold text-primary-400">500万+</span>
                <span className="text-xs text-foreground-500 mt-1">累计下载量</span>
              </div>
              <div className="w-px h-8 bg-background-300/50"></div>
              <div className="flex flex-col items-center">
                <span className="text-xl font-heading font-bold text-accent-400">4.8</span>
                <span className="text-xs text-foreground-500 mt-1">用户评分</span>
              </div>
              <div className="w-px h-8 bg-background-300/50"></div>
              <div className="flex flex-col items-center">
                <span className="text-xl font-heading font-bold text-primary-400">50MB</span>
                <span className="text-xs text-foreground-500 mt-1">轻量安装包</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}